import { FastCheckoutMachineProvider } from "@/components/Checkout/CheckoutMachine";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";

import { Link, useParams } from "react-router-dom";

import { CheckoutDetail } from "@/components/Checkout/components/CheckoutSummary/CheckoutDetail";
import { useSiteContext } from "@/components/SiteProvider";
import { styled } from "@mui/material";
import useStoreType from "@/utils/hooks/useStoreType";
import { StoreBrandingType } from "@/types/misc";

const BackLink = styled("div")(({ theme }) => ({
  color: theme.vars.palette.text.primary,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "10px",
  textDecoration: "none",
}));

const PurchaseDetail = () => {
  const { id } = useParams();
  const orderId = id;
  const storeType = useStoreType();
  const isDtc = storeType === StoreBrandingType.CustomDTCStore;
  const { routePrefix } = useSiteContext();
  const purchasesPageUrl = isDtc
    ? "/purchase"
    : routePrefix
    ? `${routePrefix}/branddashboard/purchase`
    : `/dashboard/purchase`;

  if (!orderId) {
    return <div>null</div>;
  }

  return (
    <>
      <Link to={purchasesPageUrl} style={{ textDecoration: "none" }}>
        <BackLink>
          <ChevronLeftRoundedIcon
            sx={{ fontSize: "18px", marginLeft: "-3px" }}
          />
          All purchases
        </BackLink>
      </Link>
      <FastCheckoutMachineProvider orderId={orderId}>
        <CheckoutDetail fullWidth receiptPage />
      </FastCheckoutMachineProvider>
    </>
  );
};

export default PurchaseDetail;
